/*eslint-disable */
import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs";

const state = {
  passionProjectResponse: cacheLs.get_passion_project_response(),
  lastUpdatedTime: null
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}